import PageIntro from "../components/PageIntro"; 
import PageNav from "../components/PageNav";
import { CsrData } from "../content/CsrData";
import { BsFileEarmarkPdf } from "react-icons/bs";

const csr_doc= () =>{
    const annualReportUrl =
    "";
    return(
        <>
        <PageIntro title="CSR Documents"
        subtitle=""
        compactBottom
        contentWidthClass="max-w-[1400px]"
        bottomPadding="pb-4 md:pb-6">  
        <PageNav data={CsrData} isFlush />
      </PageIntro>
     
    {CsrData.page.map((section, index) => {
            const isAnnualReport = section.title === "Annual Report";
            const hasData = section.sections && section.sections.length > 0;
    
            const sectionId = section.title
              ? section.title.replace(/\s+/g, "-").toLowerCase()
              : `section-${index}`;
    
            return (
              <section
                id={sectionId}
                key={sectionId}
                className={`px-4 md:px-8 ${
                  isAnnualReport ? "bg-ofWhite" : "bg-gray-50"
                }`}
              >
                <div className="max-w-6xl mx-auto py-12 md:py-16 space-y-8">
                  {/* Header */}
                  <div className="text-center space-y-3">
                    <p className="text-xs uppercase tracking-[0.4em] text-black/50">
                      {section.title}
                    </p>
    
                    <h3 className="text-2xl md:text-3xl font-semibold text-[#1c3d72]">
                      {isAnnualReport
                        ? "Download the latest filings"
                        : hasData
                        ? "Available documents"
                        : "Information coming soon"}
                    </h3>
    
                    <p className="text-black/60 text-sm md:text-base max-w-3xl mx-auto">
                      {isAnnualReport
                        ? "Access comprehensive annual reports from Kotak Mahindra Bank, the parent entity of BSS Sonata."
                        : hasData
                        ? "Browse the available documents and disclosures below."
                        : "We are currently updating this section. Please check back for the latest policies, filings, and disclosures."}
                    </p>
                  </div>
    
                  {/* Content */}
                  {isAnnualReport ? (
                    <div className="flex flex-col items-center gap-4">
                      <a
                        href={annualReportUrl}
                        target="_blank"
                        rel="noreferrer"
                        className="inline-flex items-center gap-3 rounded-full bg-[#1c3d72] px-8 py-4 text-white text-lg font-semibold shadow-lg shadow-[#1c3d72]/30 transition hover:bg-[#152c52]"
                      >
                        View Annual Reports <span aria-hidden="true">↗</span>
                      </a>
                      <p className="text-sm text-black/50">
                        Opens kotak.bank in a new tab
                      </p>
                    </div>
                  ) : hasData ? (
                    <div className="flex justify-center">
                      <div className="grid gap-5 md:grid-cols-4 text-center max-w-5xl">
                        {section.sections.map((item, i) => (
                          <a
                            key={i}
                            href={item.url}
                            target="_blank"
                            rel="noreferrer"
                            className="block"
                          >
                            <div className="rounded-2xl border bg-[#f1e9ec] p-6 shadow-sm h-48 flex flex-col items-center" style={{width: "160px"}}>
                              <BsFileEarmarkPdf className="mb-4 text-7xl text-[#1c3d72]" />
    
                              <div className="h-12 flex items-start justify-center">
                                <p className="text-sm font-medium text-[#1c3d72] leading-snug">
                                  {item.title}
                                </p>
                              </div>
                            </div>
                          </a>
                        ))}
                      </div>
                    </div>
                  ) : (
                    <div className="rounded-[32px] border border-dashed border-black/10 bg-white shadow-sm px-6 py-12 text-center">
                      <p className="text-base md:text-lg text-black/50">
                        No documents are available for this section yet.
                      </p>
                    </div>
                  )}
                </div>
              </section>
            );
          })}
        </>
      );
    };
export default csr_doc;